import { render, staticRenderFns } from "./FarmersPage.vue?vue&type=template&id=12a54f60&scoped=true"
import script from "./FarmersPage.vue?vue&type=script&lang=js"
export * from "./FarmersPage.vue?vue&type=script&lang=js"
import style0 from "./FarmersPage.vue?vue&type=style&index=0&id=12a54f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a54f60",
  null
  
)

export default component.exports